export const USER_PHOTO = Symbol.for("user.photo");
export const USER_ERROR = Symbol.for("user.error");
export const USER_DATA = Symbol.for("user.data");
export const USER_COMPANIES = Symbol.for("user.companies");
export const USER_COMPANY = Symbol.for("user.company");
export const USER_WORKER = Symbol.for("user.worker");